import * as React from 'react'

export const SVG_Tick_WithCircle = (props: { color?: string; className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 81 81" className={props.className}>
        <g fill="none" fillRule="evenodd">
            <circle cx="40.5" cy="40.5" r="40.5" fill={props.color || '#4DD387'} />
            <path
                fill="#FFF"
                d="M35.553 56.173L23.805 45.046c-1.175-1.112-1.175-2.781 0-3.894s2.937-1.113 4.112 0l9.105 8.623L52.588 25.02c.88-1.39 2.643-1.669 4.112-.834 1.468.834 1.762 2.503.88 3.894L39.958 55.895c-.57.776-.869 1.39-2.195 1.39-.88 0-1.623-.556-2.21-1.112z"
            />
        </g>
    </svg>
)
